<template>
  <q-card class="resources-card">
    <q-toolbar>
      <q-toolbar-title>
        <span class="text-pink-6">Resources</span>
        <select-resource-group v-model="resourceGroup" class="q-ml-lg" />
      </q-toolbar-title>
      <q-icon name="fa fa-info-circle" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-list>
      <a
        v-for="resource in resources"
        :key="resource.title"
        :href="resource.src"
        target="_blank"
        class="link"
      >
        <q-item clickable>
            <q-item class="q-px-none">
              <q-item-section side>
                <q-icon :name="resource.icon" size="xs" />
              </q-item-section>
              <q-item-section>{{ resource.title }}</q-item-section>
            </q-item>
        </q-item>
      </a>
    </q-list>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.resources-card {
  border-bottom: 3px solid $pink-6;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import SelectResourceGroup from '@/resources/SelectResourceGroup.vue';
import {
  Resource,
  ResourceGroup,
  resourceGroups,
  findByTags,
} from '@/resources';

interface Data {
  resourceGroup: ResourceGroup
}

export default defineComponent({
  components: { SelectResourceGroup },
  data(): Data {
    return {
      resourceGroup: resourceGroups[0],
    };
  },
  computed: {
    resources(): Resource[] {
      return findByTags(this.resourceGroup.tags);
    },
  },
});
</script>
